import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useClassName from '../../../hooks/class-name';
import { files } from '../../../libs/assets';
import { PasswordWrapper } from './styled';
import MetaData from './metadata';
import Label from './label';

const Password = (props) => {
  const [type, setType] = useState('password');
  const {
    errorMessage,
    defaultValue,
    placeholder,
    description,
    onChange,
    helpText,
    disabled,
    required,
    label,
    block,
    size,
    id
  } = props;

  const fieldWrapperClassName = useClassName([
    'field-wrapper',
    size
  ]);

  const eyeIconClassName = useClassName([
    type === 'text' ? 'visible' : '',
    'eye-icon'
  ]);

  const className = useClassName([
    block ? 'block' : '',
    props.className
  ]);

  const togglePasswordVisibility = () => {
    if (type === 'password') {
      setType('text');
    } else {
      setType('password');
    }
  };

  return (
    <PasswordWrapper className={className}>
      <div className="main-wrapper">
        <Label description={description} required={required} label={label} id={id} />

        <div className={fieldWrapperClassName}>
          <input
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
            required={required}
            type={type}
            id={id}
          />
          
          <button
            onClick={togglePasswordVisibility}
            className="visibility-icon"
            type="button"
          >
            <span className={eyeIconClassName}>
              <img src={files.eyeOpen} />
            </span>
          </button>
        </div>
      </div>
      
      <MetaData errorMessage={errorMessage} helpText={helpText} />
    </PasswordWrapper>
  );
};

Password.defaultProps = {
  placeholder: 'Enter password',
  onChange: () => null,
  label: 'Password',
  defaultValue: '',
  errorMessage: '',
  size: 'default',
  floating: false,
  description: '',
  disabled: false,
  required: false,
  id: 'password',
  className: '',
  block: false,
  helpText: ''
};

Password.propTypes = {
  size: PropTypes.oneOf(['default', 'large', 'small']),
  defaultValue: PropTypes.string,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.node,
  helpText: PropTypes.node,
  floating: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  block: PropTypes.bool,
  id: PropTypes.string,
};

export default Password;